"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackClickComCta = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackClickComCta = (clickText, clickElement) => {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ClickEcomCta,
            feature_category: enums_1.GA4FeatureCategory.DirectBooking,
            click_text: clickText,
            click_element: clickElement,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackClickComCta = trackClickComCta;
//# sourceMappingURL=trackClickComCta.js.map